import React, { useState } from "react";
import "./Modal.scss";
import { Typography } from "core/typography/Typography";
import { FormattedMessage } from "react-intl";
import ReactDom from "react-dom";
import ModalFooter from "./ModalFooter";
import { MODAL_CONTENT } from "constants/constants";
import LightSelect from "components/light-select/LightSelect";
import { COLORS } from "utils/modalsHelper";

const LightModal = ({
  onClose,
  open,
  onValidate,
  defaultValue,
  setTrafficLightNewValue,
}) => {
  const [bgColor, setBgColor] = useState(COLORS.center.bg);
  const [inputColor, setInputColor] = useState(COLORS.center.input);

  const getSwitchButtonValue = (val) => {
    const colorConfig = COLORS[val] || COLORS.center;
    setBgColor(colorConfig.bg);
    setInputColor(colorConfig.input);
    return setTrafficLightNewValue(colorConfig.status);
  };

  if (!open) return null;

  return ReactDom.createPortal(
    <>
      <div className="overlay-style" />
      <div className="modal-light-select">
        <div className="header">
          <Typography
            className="title-3 violet text-uppercase"
            type="h2"
            label={
              <FormattedMessage
                id="traffic_light_update"
                defaultMessage="Modification le feu"
              />
            }
          />
        </div>
        <div className="modal_body">
          <LightSelect
            onChange={getSwitchButtonValue}
            bgColor={bgColor}
            inputColor={inputColor}
            defaultValue={defaultValue}
          />
          <div className="modal-explanation">
            {Object.entries(COLORS).map(([key, { bg, input }]) => (
              <p key={key} className={`explanation ${key}-dot`}>
                <span
                  style={{
                    backgroundColor: input,
                    border: `3px solid ${bg}`,
                  }}
                ></span>
                <FormattedMessage
                  id={COLORS[key].legend}
                  defaultMessage="Explication du feu"
                />
              </p>
            ))}
          </div>
          <br /> <br />
          <ModalFooter
            onClose={onClose}
            onValidate={onValidate}
            modalType={MODAL_CONTENT.MANAGE_DAILY_FEE}
            cancelButton="cancel"
            validButton="validate"
          />
        </div>
      </div>
    </>,
    document.getElementById("portal")
  );
};

export default LightModal;
